import React, { Component } from 'react'
import './footer.css'

export default class Footer extends Component {
  render() {
    return (
      <>
        <div className='ftr'>
            <h1>Footer Section</h1>
        </div>
      </>
    )
  }
}
